import dayjs from 'dayjs';
import { atomWithReset } from 'jotai/utils';

import type { TutorUsageFilters } from '../../types/tutorAi';
import { USAGE_DEFAULT_RANGE_DAYS } from '../../utils/tutorAiLimits';

/**
 * Filtros default do dashboard: janela de {@link USAGE_DEFAULT_RANGE_DAYS} dias
 * terminando hoje, sem recorte de turma.
 */
export function buildDefaultUsageFilters(): TutorUsageFilters {
  const today = dayjs();
  return {
    dateStart: today.subtract(USAGE_DEFAULT_RANGE_DAYS - 1, 'day').format('YYYY-MM-DD'),
    dateEnd: today.format('YYYY-MM-DD'),
    classStudentId: '',
    classStudentName: '',
  };
}

/**
 * Filtros ativos do dashboard de uso e custos.
 *
 * Resetável para permitir "Limpar filtros" sem recalcular as datas na tela.
 * Acesse sempre via `useTutorUsageFilters` — nunca `useAtom` direto no componente.
 */
export const tutorUsageFiltersAtom = atomWithReset<TutorUsageFilters>(buildDefaultUsageFilters());
